.exportItem{
    display: flex;
    gap: 8px;
    align-items: center;
    width: 100%;
    margin-left: 5px;
}